import React from "react";
import { CustomLink } from "../../components";
import { generalIcons, views } from "../../utils/constants";
import SortByDropdown from "./SortByDropdown";
import { useNavigate } from "react-router-dom";

export default function Filters({
  searchQuery,
  setSearchQuery,
  selectedSortOption,
  setSelectedSortOption,
  setView,
  view,
}) {
  const navigate = useNavigate();
  const pathName = window?.location?.pathname;

  const handleViewToggle = (currentView) => {
    setView(currentView);
    localStorage?.setItem("previousView", currentView);
  };

  return (
    <div className="flex items-center justify-between w-full flex-wrap md:flex-nowrap gap-4 flex-1">
      <div className="flex items-center flex-wrap sm:flex-nowrap gap-3 w-full md:w-fit *:w-full *:sm:w-[50%] *:md:w-fit">
        {pathName !== "/all-validator" && (
          <CustomLink
            id="seeAll"
            onClick={() => navigate("/all-validator")}
            className="bg-[#1A1A1A] !rounded-[10px] py-2 px-4 hover:text-green h-10 hidden md:flex whitespace-nowrap !font-normal"
          >
            See All
            <span className="ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="12"
                viewBox="0 0 6 12"
                fill="none"
              >
                <path
                  d="M1 1L5 6L1 11"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </CustomLink>
        )}

        <div className="block md:hidden h-10">
          <SortByDropdown
            selectedSortOption={selectedSortOption}
            setSelectedSortOption={setSelectedSortOption}
          />
        </div>
      </div>

      <div className="flex gap-3 items-center justify-end h-10 w-full">
        {/* {totalRecords && view === 'list' ? <CustomPagination
          totalRecords={totalRecords}
          startRecord={startRecord}
          endRecord={endRecord}
          page={page}
          onPageChange={onPageChange}
        />:""} */}
        <div className="bg-[#1A1A1A] rounded-[10px] px-[10px] py-[8px] flex gap-2 w-full md:w-fit min-w-[150px] laptop:min-w-[250px] h-10">
          <span className="">{generalIcons.search}</span>
          <input
            type="text"
            placeholder="Search Validators"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="text-white placeholder:text-white/50 bg-[#1A1A1A] text-[14px] font-normal w-full"
          />
        </div>

        <div className="hidden md:block h-10">
          <SortByDropdown
            selectedSortOption={selectedSortOption}
            setSelectedSortOption={setSelectedSortOption}
          />
        </div>

        <div className="hidden lg:flex items-center p-[6px] rounded-[10px] bg-[#1A1A1A] text-white gap-4 text-sm leading-none font-normal h-10">
          {Object.entries(views).map(([key, value]) => (
            <div
            id="gridView"
              key={key}
              className={`flex items-center justify-center capitalize p-1 rounded-lg cursor-pointer ${
                key === view
                  ? "bg-green/[.12] text-green"
                  : "text-primaryWhite/25"
              }`}
              onClick={() => {
                handleViewToggle(key);
              }}
            >
              <span className="w-6 h-6 flex items-center justify-center">
                {value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
